import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import Store from './redux/store';
import Config from './utils/Config';
import './utils/localStoragePolyfill';
import App from './App';
import * as Logger from './utils/logger';

Config.setup();
Logger.setup();

Store.init().then(store => {
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('root')
  );
});
